/**
 * TopBar Class
 */
export class TopBar {

	/**
	 * Header element.
	 * @type {HTMLElement|null}
	 */
	#topBar;

	/**
	 * Hamburger menu buttons - mobile and desktop.
	 * @type {NodeListOf<HTMLElement>|null}
	 */
	#closeBtn;

	/**
	 * Creates an instance of a class.
	 *
	 * @return {void} Returns nothing.
	 */
	constructor() {


		this.#topBar   = document.querySelector( '.top-bar' );
		this.#closeBtn = this.#topBar?.querySelectorAll( '.top-bar__close' );


		this.init();

	}

	/**
	 * Initializes header functionality.
	 *
	 * @return {void} Returns nothing.
	 */
	init = () => {

		this.closeTopBar();

	}

	closeTopBar = () => {

		if ( ! this.#topBar || ! this.#closeBtn ) {

			return;

		}

		this.#closeBtn.forEach( btn => {

			btn.addEventListener( 'click', () => {

				this.#topBar.remove();

			} )

		} );


	}

}